<template>
	<div class="pt-5 supply-drop-page">
		<h2 class="level-one-heading mb-5">Supply Drop</h2>
		<hr class="_strong">
		<div class="mb-5">
			<b>Weekly</b> – levereras en gång i veckan.<br>
			<b>Activity</b> – varje uthämtad beställning för dig närmare nästa Activity Supply Drop!<br>
			<b>Level up</b> – denna supply drop levereras varje gång din Avatar levlar upp.
		</div>
		<div class="supply-wrap">
			<div class="mb-5 mx-4">
				<div>
					<ul class="nav nav-tabs pl-4">
						<li v-for="(crate, index) in crateTypes" :key="'crate-' + index" :class="{ active: selectedCrateTypeIndex === index }">
							<a :title="crate.name" @click="selectedCrateTypeIndex = index" class="crate-tab text-center">
								<img height="20" class="pixelated" :src="convertToCdnUrl(crate.icon)" alt="pixelated" >
								<div class="crate-progress-container" style="pointer-events: none;">
									<div class="crate-progress-bar" :class="{ '_full': crate.progress >= 0.9999 /* @TODO and type is not levelup */ }" :style="{ width: Math.round(crate.progress * 100) + '%' }"/>
								</div>
								<div class="crate-name">
									{{ crate.name }}
								</div>
								<span v-if="crate.openableCount" class="ap-tr crate-count">
									x{{ crate.openableCount }}
								</span>
							</a>
						</li>
					</ul>
				</div>
				<dropper-weekly v-if="selectedCrateTypeIndex === 0" :drops="drops" :user="user" :nextDropTime="nextDropTime" @open="onOpened(selectedCrateType)" />
				<dropper-activity v-else-if="selectedCrateTypeIndex === 1" :selectedCrateType="selectedCrateType" :drops="drops" :user="user" @open="onOpened(selectedCrateType)" />
				<dropper-level-up v-else :crateType="selectedCrateType" :drops="drops" :user="user" @open="onOpened(selectedCrateType)" />
			</div>
			<div class="supply-drop-container" ref="dropContainer">
				<div>
					<div v-for="box in boxCount" :key="'supply-drop-item-' + box" class="supply-drop-box">
						<supply-drop-item :drop="drops[box - 1]" />
					</div>
				</div>
				<div class="clearfix" ref="clearFix" />
			</div>
		</div>
		<div class="mb-5 pixelated" style="position: relative; overflow: hidden; line-height: 0">
			<img :src="convertToCdnUrl('/img/member/supply-drop/airplane-small.gif')" style="position: absolute; top: 11%; height: 25%;" :style="{ left: airplanePosition + '%' }" />
			<img :src="convertToCdnUrl('/img/member/supply-drop/supply-drop-map-top.png')" style="width: 100%;">
			<img :src="convertToCdnUrl('/img/member/supply-drop/supply-drop-map-lake.png')" style="margin-top: -0.1px; width: 100%;">
			<canvas width="794" height="46" style="margin-top: -0.1px; width: 100%;" ref="canvas" />
		</div>
		<div class="clearfix" />
	</div>
</template>

<script>
import Vue from 'vue';
import { throttle } from 'lodash';
import waja from 'waja';
import supplyDropItem from './item';
import { convertToCdnUrl } from 'utils';
import dropperWeekly from './dropper-weekly.vue';
import dropperActivity from './dropper-activity.vue';
import dropperLevelUp from './dropper-level-up.vue';

export default {
	components: {
		dropperWeekly,
		supplyDropItem,
		dropperLevelUp,
		dropperActivity,
	},
	props: {
		user: {
			type: Object,
		},
	},
	data () {
		return {
			// new stuff
			crateTypes: [],
			selectedCrateTypeIndex: 0,

			minBoxCount: 10,

			drops: [],
			newDrop: null,

			airplanePosition: -100, // på kartan

			nextDropTime: 0,
		};
	},
	beforeRouteEnter (to, frm, next) {
		waja.get('supply-drop')
			.on('success', res => {
				next(vm => {
					vm.drops = res.data.drops;
					vm.latestDropTime = res.data.latestDropTime;
					vm.airplanePosition = res.data.airplanePosition;
					vm.nextDropTime = res.data.nextDropTime;
					vm.crateTypes = res.data.crateTypes;
					vm.enforceMinimumDropTime();
				});
			}).go();
	},
	mounted () {
		this.generateWaves();

		Vue.nextTick(this.throttledResize);
		window.addEventListener('resize', this.throttledResize);
	},
	beforeDestroy () {
		window.removeEventListener('resize', this.throttledResize);
	},
	computed: {
		selectedCrateType () {
			return this.crateTypes[this.selectedCrateTypeIndex];
		},
		throttledResize () {
			return throttle(this.calcMinBoxCount.bind(this), 100);
		},
		boxCount () {
			return Math.max(this.drops.length, this.minBoxCount);
		},
	},
	methods: {
		convertToCdnUrl,
		onOpened (crateType) {
			crateType.openableCount--;

			// Finns en del data som blir bökigt att fixa på annat vis.
			// Kanske vill vi skicka med denna info i själva öppningsanropet?
			// Vi behöver _inte_ hämta alla grejer igen egentligen..
			waja.get('supply-drop')
				.on('success', res => {
					setTimeout(() => {
						this.drops = res.data.drops;
					}, 1500);
					this.latestDropTime = res.data.latestDropTime;
					this.airplanePosition = res.data.airplanePosition;
					this.nextDropTime = res.data.nextDropTime;
					this.crateTypes = res.data.crateTypes;
					this.enforceMinimumDropTime();
				}).go();
		},
		enforceMinimumDropTime () { // weekly drop time
			const secs = this.getSecondsLeft();
			if (secs <= 3) {
				this.nextDropTime -= secs - 3.5;
			}
		},
		getSecondsLeft () {
			const distance = (this.nextDropTime * 1000) - Date.now();
			return Math.floor((distance % (1000 * 60)) / 1000);
		},
		generateWaves () {
			const image = new Image();
			image.onload = () => {
				const canvas = this.$refs.canvas;
				const ctx = canvas.getContext('2d');
				const frames = [];
				const waveScale = 0.3;
				ctx.drawImage(image, 0, 0, 794, 46, 0, 0, 794, 46);
				for (let f = 0; f < 30; ++f) {
					const time = f * (Math.PI * 2 / 30);
					for (let i = 0; i < 46; i++) {
						const distanceFactor = Math.min(1, (45 - i) / 32);
						const distance = ((0.5 + Math.sin(time + i * waveScale) * 0.5) * 6) * distanceFactor;
						ctx.drawImage(image, 0, distance + i, 794, 1, -distance, 0, 794 + distance * 2, 46 - i);
					}
					const img = new Image();
					img.src = canvas.toDataURL('image/png');
					frames.push(img);
				}
				let frame = 0;
				this.interval = setInterval(() => {
					++frame;
					if (frame >= frames.length) {
						frame = 0;
					}
					ctx.drawImage(frames[frame], 0, 0);
				}, 66);
			};
			image.crossOrigin = 'Anonymous';
			image.src = convertToCdnUrl('/img/member/supply-drop/supply-drop-map-lake.png');
		},
		calcMinBoxCount () {
			const container = this.$refs.dropContainer;
			if (! container) {
				return;
			}
			const rect = container.getBoundingClientRect();

			const clr = this.$refs.clearFix;
			const width = clr ? clr.getBoundingClientRect().width : rect.width;

			this.minBoxCount = Math.floor(width / 72) * Math.floor(rect.height / 72);
		},
	},
};
</script>
